const API_BASE = (process.env.VUE_APP_API_BASE || 'https://api.codebin.xin').replace(/\/$/, '')

/** 将数据库/本地上传返回的文件地址转为线上可访问地址 */
export function fileUrl(url) {
  if (!url || typeof url !== 'string') return url
  const trimmed = url.trim()
  if (!trimmed) return trimmed

  if (trimmed.startsWith('/file/')) {
    const matchRel = trimmed.match(/^\/file\/download\/(.+)$/)
    if (matchRel) {
      return `${API_BASE}/file/download/${encodeDownloadName(matchRel[1])}`
    }
    return `${API_BASE}${trimmed}`
  }

  const match = trimmed.match(/\/file\/download\/([^?#]+)/)
  if (match) {
    return `${API_BASE}/file/download/${encodeDownloadName(match[1])}`
  }

  if (/^https?:\/\//i.test(trimmed) && !/localhost|127\.0\.0\.1/i.test(trimmed)) {
    return trimmed
  }

  return trimmed
}

/** 正确编码下载文件名：保留已有编码，并把 + 编成 %2B，避免被服务器当成空格 */
function encodeDownloadName(raw) {
  let name = raw
  try {
    // 若本身已是编码串，先还原再统一编码
    name = decodeURIComponent(raw.replace(/\+/g, '%2B'))
  } catch (e) {
    name = raw.replace(/\+/g, ' ')
  }
  return encodeURIComponent(name)
}

/** 富文本 HTML 中的图片/视频链接替换为线上地址，并为图片补上懒加载 */
export function fixFileUrlsInHtml(html) {
  if (!html || typeof html !== 'string') return html
  let out = html.replace(
    /https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?(\/file\/download\/[^"'>\s]+)/gi,
    `${API_BASE}$1`
  )
  let imgIndex = 0
  out = out.replace(/<img\b([^>]*?)(\/?)>/gi, (full, attrs, selfClose) => {
    imgIndex += 1
    let a = attrs || ''
    // 前两张优先加载（靠近首屏），其余懒加载，减轻同时解码卡顿
    if (!/\bloading\s*=/i.test(a)) {
      a += imgIndex <= 2 ? ' loading="eager"' : ' loading="lazy"'
    }
    if (!/\bdecoding\s*=/i.test(a)) {
      a += ' decoding="async"'
    }
    if (imgIndex > 2 && !/\bfetchpriority\s*=/i.test(a)) {
      a += ' fetchpriority="low"'
    }
    if (!/\balt\s*=/i.test(a)) {
      a += ' alt=""'
    }
    return `<img${a}${selfClose || ''}>`
  })
  return out
}

export function fileUrlList(urls) {
  if (!Array.isArray(urls)) return urls
  return urls.map(fileUrl)
}
